import { useTranslation } from '@rhino-project/core/i18n';
import { useModelEditContext } from '@rhino-project/core/hooks';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { ModelBreadcrumb, ModelBreadcrumbProps } from './ModelBreadcrumb';
import { RhinoRecord } from '@rhino-project/core';

export type ModelEditHeaderProps = ModelBreadcrumbProps;

export const ModelEditHeaderBase = (props: ModelBreadcrumbProps) => {
  const { t } = useTranslation();
  const {
    show: { resource }
  } = useModelEditContext() as { show: { resource: RhinoRecord } };

  return (
    <ModelBreadcrumb
      lastItem={t('rhino.frontend.messages.edit')}
      resource={resource}
      {...props}
    />
  );
};

export const ModelEditHeader = (props: ModelBreadcrumbProps) =>
  useGlobalComponentForModel('ModelEditHeader', ModelEditHeaderBase, props);
